import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { connect } from 'react-redux';
import { selectSignUpUser } from '../../../redux/auth/selectors';
import { selectLastName } from '../../../redux/persistedSignupData/selectors';
import {
  setAuthUserData as actionSetAuthUserData,
  postAuthUserPhoto as actionPostAuthUserPhoto,
} from '../../../redux/auth/actions';

import Button from '../../../components/Button';
import ContactUs from '../components/ContactUs';
import InputFile from '../../../components/InputFile';
import ImageCropper from '../../../components/ImageCropper/ImageCropper';

import containerStyles from './UserPhoto.scss';
import qmStyles from '../../../theme/qmStyles';
import ImageService from '../../../services/ImageService';

class UserPhoto extends Component {
  static propTypes = {
    setAuthUserData: PropTypes.func.isRequired,
    postAuthUserPhoto: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      temporaryImageUrl: null,
      hasCropped: false,
    };
  }

  getRemoteImage = () => {
    const { userData } = this.props;
    if (!userData) return;

    return userData.image && !userData.image.includes('static')
      ? userData.image
      : undefined;
  };

  handlePhotoUpload = file => {
    this.setState({ temporaryImageUrl: URL.createObjectURL(file) });
  };

  handlePhotoRemoval = () => {
    const { setAuthUserData } = this.props;

    setAuthUserData({ image: null });
    this.setState({ temporaryImageUrl: null });
  };

  onCropComplete = croppedImage => {
    const { postAuthUserPhoto } = this.props;

    const payload = new FormData();

    payload.append('user_image', croppedImage, 'image.png');

    postAuthUserPhoto(payload);

    this.setState({ hasCropped: true });
  };

  renderUploadPhoto = () => {
    const { temporaryImageUrl } = this.state;
    const { userData, last_name, openTOSModal } = this.props;

    return (
      <>
        <h3 className={containerStyles.title}>Account Created!</h3>
        <div className={`qm-icon-other ${containerStyles.placeholderIcon}`} />
        <p className={containerStyles.userName}>
          {get(userData, 'first_name', '')} {last_name}
        </p>
        <p className={containerStyles.descriptionText}>
          Real faces help to build a friendlier community on Quartermaster.
        </p>
        <InputFile
          allowedTypes={['image/jpeg', 'image/png', 'image/webp']}
          image={{ image: temporaryImageUrl }}
          className={containerStyles.uploadPhoto}
          uniqueClassIdentifier="UserPhotoUpload"
          onPhotoUpload={this.handlePhotoUpload}
          styleLikeButton
          text="Upload photo"
        />
        <Button
          text="Skip"
          onClick={openTOSModal}
          style={{ marginBottom: qmStyles.doubleGutter }}
        />
      </>
    );
  };

  renderPhotoUploaded = () => {
    const { temporaryImageUrl, hasCropped } = this.state;

    const remoteImage = this.getRemoteImage();
    const disabled = !hasCropped && !remoteImage;

    return (
      <>
        <h3 className={containerStyles.title}>That's a nice photo</h3>
        <ImageCropper
          imageSrc={temporaryImageUrl}
          remoteImage={remoteImage}
          onCropComplete={this.onCropComplete}
          style={{ marginBottom: qmStyles.doubleGutter }}
        />
        <Button
          text="Remove photo"
          onClick={this.handlePhotoRemoval}
          style={{ marginBottom: qmStyles.halfGutter }}
        />
        <Button
          text="Continue"
          onClick={this.props.openTOSModal}
          style={{
            backgroundColor: disabled
              ? qmStyles.qmDisabledGreen
              : qmStyles.qmGreen,
            color: 'white',
            marginBottom: qmStyles.doubleGutter,
          }}
          disabled={disabled}
        />
      </>
    );
  };

  render() {
    const { temporaryImageUrl } = this.state;
    const { userData } = this.props;
    if (!userData) return null;

    return (
      <div className={containerStyles.container}>
        <div className={containerStyles.content}>
          {temporaryImageUrl || this.getRemoteImage()
            ? this.renderPhotoUploaded()
            : this.renderUploadPhoto()}
          <ContactUs />
        </div>
      </div>
    );
  }
}

UserPhoto.propTypes = {
  userData: PropTypes.object,
  navigateNext: PropTypes.func.isRequired,
  last_name: PropTypes.string,
};

UserPhoto.defaultProps = {
  userData: null,
  last_name: '',
};

const mapStateToProps = state => ({
  userData: selectSignUpUser(state),
  last_name: selectLastName(state),
});

const bindAction = {
  postAuthUserPhoto: actionPostAuthUserPhoto,
  setAuthUserData: actionSetAuthUserData,
};

export default connect(
  mapStateToProps,
  bindAction,
)(UserPhoto);
